import { render, staticRenderFns } from "./AppliedJobOpeningCard.vue?vue&type=template&id=0d5661ad&scoped=true"
import script from "./AppliedJobOpeningCard.vue?vue&type=script&lang=js"
export * from "./AppliedJobOpeningCard.vue?vue&type=script&lang=js"
import style0 from "./AppliedJobOpeningCard.vue?vue&type=style&index=0&id=0d5661ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5661ad",
  null
  
)

export default component.exports